import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c74b0fe2"
import script from "./addSubModule.js?vue&type=script&lang=js&external"
export * from "./addSubModule.js?vue&type=script&lang=js&external"
import style0 from "./addSubModule.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports